import { Link } from '~/components/Link';
import { type ReactNode } from 'react';
import { Spacing } from '~/components';
import { IcChevronDown, Typography } from '@bgzt/ui';
import styles from './Accordion.module.scss';

interface Props {
  data: {
    summary: string;
    details: {
      heading?: ReactNode;
      description: ReactNode;
      link?: {
        to: string;
        label: ReactNode;
      };
    };
  }[];
}

export function Accordion({ data }: Props) {
  return (
    <div className={styles.wrapper}>
      {data.map(({ summary, details }, index) => (
        <details key={index}>
          <summary>
            {summary}
            <div>
              <IcChevronDown size={20} fill="currentColor" />
            </div>
          </summary>
          <div className={styles.text}>
            {details.heading && (
              <>
                <Typography as="strong" variant="S4" color="gray-600">
                  {details.heading}
                </Typography>
                <Spacing height={10} />
              </>
            )}
            <Typography variant="B5" color="gray-600">
              {details.description}
            </Typography>
            {details.link && (
              <>
                <Spacing height={10} />
                <Link href={details.link.to} className={styles.link}>
                  {details.link.label}
                </Link>
              </>
            )}
            <Spacing height={20} />
          </div>
        </details>
      ))}
    </div>
  );
}
